import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateSmokerRateOverrideRule } from '../../../api/plan-smoker-rate-override-rules-api'
import type {
  PlanSmokerRateOverrideRuleResponseDto,
  UpdatePlanSmokerRateOverrideRuleRequestDto,
} from '../../../api/dto/plan-smoker-rate-override-rules.dto'
import { SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanSmokerRateOverride/hooks/useGetSmokerRateOverrideRules'
import { SMOKER_RATE_OVERRIDE_RULE_QUERY_KEY } from './useGetSmokerRateOverrideRule'

export function useUpdateSmokerRateOverrideRule(id: string) {
  const queryClient = useQueryClient()

  return useMutation<
    PlanSmokerRateOverrideRuleResponseDto,
    unknown,
    UpdatePlanSmokerRateOverrideRuleRequestDto
  >({
    mutationFn: (body) => updateSmokerRateOverrideRule(id, body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULE_QUERY_KEY, id],
      })
    },
  })
}
